export const GET_DATER = "GET_DATER";
export const GET_DATER_FAIL = "GET_DATER_FAIL";
export const GET_DATER_SUCCESS = "GET_DATER_SUCCESS";
